import { Spinner } from '@iwoca/orion';
import { Trans } from '@lingui/react/macro';
import clsx from 'clsx';
import { useNumberFormat } from 'hooks/useNumberFormat';
import { useGetRCFRepaymentSummary } from 'lendingApi/lendingApiHooks';
import styles from '../../SummaryCard.module.css';

type TProps = {
  offerId: string;
  maxAmount: number;
  offerIsSelected: boolean;
  offerNotSelected: boolean;
};

export const FirstMonthlyPayment = ({
  offerId,
  maxAmount,
  offerIsSelected,
  offerNotSelected,
}: TProps) => {
  const { formatCurrency } = useNumberFormat();
  const { data, isLoading } = useGetRCFRepaymentSummary(offerId, maxAmount);

  const repaymentAmount =
    data?.data?.summary?.simplified_schedule?.next_repayment?.amount;

  if (isLoading) {
    return (
      <div className={styles.loaderContainer}>
        <Spinner dataTestId="spinner" />
      </div>
    );
  }

  return (
    <div
      className={clsx(styles.value, {
        [styles.selectedValue]: offerIsSelected,
        [styles.unselectedValue]: offerNotSelected,
      })}
    >
      {repaymentAmount ? (
        <>
          {formatCurrency(repaymentAmount)}{' '}
          <span className={styles.valueSubtext}>
            (<Trans>expected</Trans>)
          </span>
        </>
      ) : (
        '-'
      )}
    </div>
  );
};
